import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToasterHelper } from '@app/shared/helpers';

export const globalHttpInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    const messageService = inject(MessageService);

    request = request.clone({
        setHeaders: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
    });

    return next(request).pipe(
        catchError(response => {
            if (response?.status === 403) {
                router.navigate(['unauthorized']);
                return throwError(() => response);
            }

            if (response?.status === 500) {
                messageService.add(ToasterHelper.error());
                return throwError(() => response);
            }

            const backendError = response?.error?.message || response?.error?.Message || '';

            if (response?.status === 400) {
                messageService.add(
                    ToasterHelper.error(
                        backendError || "We're having trouble processing this request. Please try again soon."
                    )
                );
                return throwError(() => response);
            }

            messageService.add(ToasterHelper.error(backendError));
            return throwError(() => response);
        })
    );
};
